module.exports = __webpack_public_path__ + "static/djawn_logo-e545457490bc792d45b10ee53ae56a28.png";